<template>
  <!-- 基础信息 -->
  <div class="salesman-form-base" v-if="formData">
    <Button class="save-btn border" ghost v-if="$units.pointAction('org_1_3') && disabled" type="primary" @click="disabled=false">编辑</Button>
    
    <div v-if="$units.pointAction('org_1_3') && !disabled">
      <Button class="save-btn"  type="primary" @click="save()">保存</Button>
      <Button class="save-btn left" ghost type="primary" @click="$refs.form.resetFields();$emit('success',formData.id)">取消</Button>
    </div>
    <Form ref="form" :model="formData" :label-width="100" class="page-form"  :key="formData.id">
      <FormItem prop="code" label="内部组织编码" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.code" placeholder="请输入" :disabled="disabled||[2,3,4].includes(userInfo.orgType*1)"/>
      </FormItem>
      <FormItem prop="name" label="团队名称" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" :disabled="disabled" maxlength="16"/>
      </FormItem>
      <FormItem prop="parentName" label="上级团队" v-if="formData.parentName">
        <Input :value="formData.parentName" placeholder="请输入" disabled/>
      </FormItem>
      <FormItem prop="contacts" label="联系人">
        <Input v-model="formData.contacts" placeholder="请输入" :disabled="disabled"/>
      </FormItem>
      <FormItem prop="mobile" label="联系电话" :rules="oldMobile?{}:$units.formRule.tel('请输入正确的手机号',false)">
        <Input v-model="formData.mobile" placeholder="请输入" :disabled="disabled" @on-change="mobileChange"/>
      </FormItem>
      <FormItem prop="leaderId" label="团队长">
        <Input :value="formData.leaderName||'暂无'" placeholder="请输入" disabled v-if="disabled"/>
        <Select v-else v-model="formData.leaderId" placeholder="请选择" filterable>
          <Option v-for="(item,i) in userList" :value="item.id" :key="i">
            <i class="dian" :class="{'red': item.workingState == 0 ,'orange':item.isSus == 1 }"></i>
            {{ item.staffNo?item.name+'-'+item.staffNo:item.name }}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="sortNum" label="排序" v-if="formData.orgType!=1">
        <template slot="label">
          排序
          <Tooltip content="数字越大，顺序越靠前" placement="top">
            <Icon type="md-help-circle" style="color:#A8ADB7" />
          </Tooltip>
        </template>
        <Input v-model="formData.sortNum" placeholder="请输入" :disabled="disabled"/>
      </FormItem>
      <FormItem label="所在地区">
        <Input :value="formData.province+formData.city" placeholder="" v-if="disabled" disabled/>
        <template v-else>
          <Select v-model="formData.province" placeholder="省" @on-change="provinceChange" filterable style="width:calc(50% - 5px)">
            <Option v-for="(item,i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
          <Select v-model="formData.city" placeholder="市" filterable style="width:calc(50% - 5px);margin-left:10px">
            <Option v-for="(item,i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
        </template>
      </FormItem>
      <FormItem prop="templateName" label="服务费模板">
        <Input :value="formData.templateName" placeholder="请输入" disabled/>
      </FormItem>
      <FormItem prop="remark" label="备注" class="full">
        <Input v-model="formData.remark" type="textarea" placeholder="最多不超过50个字" maxlength="50" :autosize="{ minRows: 3}" show-word-limit  :disabled="disabled"/>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
export default {
  components: {uploadNew},
  props: {
    formData:null,
    curTreeData:null,
  },
  data() {
    return {
      disabled:true,
      oldMobile:"",
      orgTypeMap:{
        "1":"总部",
        "2":"省分机构",
        "3":"市级机构",
        "4":"区级机构",
        "5":"渠道",
      },
      userList:[],//负责人列表
      regionsArr:[],//区域数据
      cityList:[],//市级数据
      userInfo:{},
    };
  },
  watch: {
    disabled:{
      handler(){
        this.$emit("isEdit",!this.disabled);
        // if(this.disabled){
        //   this.$refs.form&&this.$refs.form.resetFields();
        // }
      },
      immediate:true,
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
  },
  methods: {
    setData(data){
      console.log("setData",data);
      this.oldMobile = data.mobile;
      this.disabled = true;
      this.getUserList(data);
      this.getRegion(data);
    },
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(this.oldMobile == formData.mobile){
          delete formData.mobile
        }
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: "/buz/organizationGroup/edit",
          apiPermissionCode:'org_1_3',
          data: formData
        }).then(res => {
          this.$notice.success("保存成功");
          this.visible = false;
          this.oldMobile = this.formData.mobile;
          this.$emit("success",res.data.id);
        }).finally(res => {
          this.loading = false;
        });
      })
    },
    // 负责人列表
    getUserList(data){
      this.$http({
        url: "/buz/userBase/getByGroup",
        type: "GET",
        data: {
          groupId:data.id,
        },
      }).then((res) => {
        this.userList = res.data;
      });
    },
    // 获取省市区域数据
    async getRegion(data) {
      this.regionsArr = await this.$store.dispatch("getRegion");
      if(data.province){
        const city = this.regionsArr.find(item=>{
          return item.name == data.province;
        })
        this.cityList = city.children;
      }
    },
    // 选择省
    provinceChange(name){
      this.$set(this.formData, "city", "")
      const data = this.regionsArr.find(item=>{
        return item.name == name;
      })
      this.cityList = data.children;
    },
    // 手机号修改
    mobileChange(){
      this.oldMobile = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35BF3F;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #E3461F;
  }
}
/deep/ .ivu-select-item {
  font-size: 12px !important;
}
@media screen and (min-width: 1200px) {
  .salesman-form-base {
    overflow: hidden;
  }
  .page-form {
    margin-right: -30px;
  }
  .page-form .ivu-form-item {
    padding-right: 30px;
  }
}
</style>